import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

const BreadcrumbItem = ({ children, className, tag: Tag, ...rest }) => (
  <Tag className={classnames(className, 'breadcrumb-item')} data-testid="BreadcrumbItem" {...rest}>
    {children}
  </Tag>
);

BreadcrumbItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

BreadcrumbItem.defaultProps = {
  children: null,
  className: null,
  tag: 'span',
};

export default BreadcrumbItem;
